/*!
  Machina, by Koding Themes
  machina-animations.js
  https://kodingthemes.com
*/

//register plugins
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
let globalAnimation = {
  animationEffects: function (e) {
    var initialScrollY =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;
    // product page — pin product info via GSAP ScrollTrigger
    if (document.body.getAttribute("id") == "product") {
      var faqs = document.querySelectorAll(
        "#product-info .product-accordion-item, .product-details-tabs li a, .product-accordions-wrapper .accordion-title"
      );
      if (faqs.length > 0) {
        faqs.forEach(function (faq) {
          faq.addEventListener("click", function (event) {
            var target =
              event.target != null && event.target.closest != null
                ? event.target.closest("a")
                : null;
            if (
              target != null &&
              (target.getAttribute("href") == "#" ||
                target.getAttribute("href") == "")
            ) {
              event.preventDefault();
            }
          });
        });
      }
      var productInfo = document.querySelector("#product-info");
      var productMedia = document.querySelector("#product-media");
      var productThumbnail = document.querySelector("#product-media-thumbnail");
      if (productInfo && productMedia) {
        ScrollTrigger.matchMedia({
          "(min-width: 768px)": function () {
            ScrollTrigger.create({
              trigger: productMedia,
              start: "top top",
              end: "bottom bottom",
              pin: productInfo,
              pinSpacing: false,
            });
            if (productThumbnail) {
              ScrollTrigger.create({
                trigger: productMedia,
                start: "top top",
                end: "bottom bottom",
                pin: productThumbnail,
                pinSpacing: false,
              });
            }
          },
        });
      }
    }
    //animate sections
    if (window.theme.sectionsAnimation == "true") {
      if (document.body.getAttribute("id") != "collection") {
        var shopifySections = gsap.utils.toArray(".shopify-section");
        if (shopifySections != null) {
          var j = 0;
          ScrollTrigger.matchMedia({
            "(min-width: 768px)": function () {
              shopifySections.forEach(function (sectionItem, i) {
                sectionItem.classList.add("animation-applied-element");
                if (
                  sectionItem.querySelector("header") == null &&
                  sectionItem.querySelector(".main-footer") == null &&
                  sectionItem.querySelector("#product-media") == null
                ) {
                  j = j + 1;
                  // Skip animation for sections already in viewport on load
                  var rect = sectionItem.getBoundingClientRect();
                  if (rect.top < window.innerHeight && e.type == "DOMContentLoaded") {
                    gsap.set(sectionItem, { autoAlpha: 1, y: 0 });
                  } else {
                    var anim1 = gsap.fromTo(
                      sectionItem,
                      {
                        autoAlpha: 0,
                        y: 50,
                      },
                      {
                        duration: 1,
                        autoAlpha: 1,
                        y: 0,
                      }
                    );
                    ScrollTrigger.create({
                      trigger: sectionItem,
                      animation: anim1,
                      start: "top 95%",
                      end: "top 60%",
                      markers: false,
                      scrub: 1.5,
                      once: true,
                    });
                  }
                }
              });
            },
          });
        }
      }
    }
    // flicker debugger — skip product page to avoid layout shift from will-change
    if (document.body.getAttribute("id") != "product") {
      window.addEventListener("load", (event) => {
        var flickerSelectors = [".product-grid", "#page-cart"];
        flickerSelectors.forEach(function (sl, index) {
          var item = document.querySelector(sl);
          if (item != null) {
            item.style.setProperty("will-change", "transform, opacity");
          }
        });
      });
    }
    if (
      e != null &&
      e.type == "DOMContentLoaded" &&
      initialScrollY > 0 &&
      document.body.getAttribute("id") != "product"
    ) {
      // Delay scroll restoration until after GSAP/ScrollTrigger has initialized
      requestAnimationFrame(function () {
        var currentScrollY =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop ||
          0;
        if (currentScrollY === 0) {
          window.scrollTo(0, initialScrollY);
          ScrollTrigger.refresh();
        }
      });
    }
  },
  animationEffectsOnImages: function(){
    // scrolltrigger for each section img
    gsap.utils.toArray(".image-scale-animation img").forEach((target) => {
      gsap.set(target, {
        scale:1.1,
      });
      gsap.to(target,{scale:1,
        scrollTrigger:{
          trigger: target,
          start:'top 100%',
          end:'top 0%',
          markers:false,
          scrub:true,
          toggleActions:'play none none reverse',
        }
      });
    });
  }
};
document.addEventListener("DOMContentLoaded", function (e) {
  // globalAnimation.animationEffectsOnImages();
});
document.addEventListener("shopify:section:load", function (e) {
  // globalAnimation.animationEffectsOnImages();
});
document.addEventListener("shopify:section:unload", function (e) {
  // globalAnimation.animationEffectsOnImages();
});
document.addEventListener("shopify:section:reorder", function (e) {
  // globalAnimation.animationEffectsOnImages();
});
if (Shopify.designMode != true) {
  document.addEventListener("DOMContentLoaded", function (e) {
    globalAnimation.animationEffects(e);
  });
  document.addEventListener("shopify:section:load", function (e) {
    globalAnimation.animationEffects(e);
  });
  document.addEventListener("shopify:section:unload", function (e) {
    globalAnimation.animationEffects(e);
  });
  document.addEventListener("shopify:section:reorder", function (e) {
    globalAnimation.animationEffects(e);
  });
  document.addEventListener("DOMContentLoaded", function () {
    var checkbox = document.querySelector(".RecipientCheckbox");
    if (checkbox != null) {
      checkbox.addEventListener("click", function (e) {
        globalAnimation.animationEffects(e);
      });
    }
  });
}

//product card animations
var sectionAnimation = {
  _cardsBatchTrigger: null,
  cardsAnimation: function (e) {
    // Kill previous batch trigger to avoid duplicates on resize/reload
    if (sectionAnimation._cardsBatchTrigger) {
      sectionAnimation._cardsBatchTrigger.forEach(function(st) { st.kill(); });
      sectionAnimation._cardsBatchTrigger = null;
    }
    var cards = document.querySelectorAll(".product-card-item:not(.product-item-loaded)");
    if (cards.length === 0) return;
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    cards.forEach(function(card) {
      var rect = card.getBoundingClientRect();
      if (rect.top >= viewportHeight) {
        gsap.set(card, { opacity: 0, willChange: "transform" });
      }
    });
    gsap.set(".product-card-item.product-item-loaded", {
      clearProps: "all",
    });
    sectionAnimation._cardsBatchTrigger = ScrollTrigger.batch(".product-card-item", {
      onEnter: (batch) =>
        gsap.to(batch, {
          autoAlpha: 1,
          stagger: 0.2,
        }),
      markers: false,
      start: "top 85%",
    });
  },
};

if (window.theme.sectionsAnimation == "true") {
  if (Shopify.designMode != true) {
    document.addEventListener(
      "shopify-collection-loader:init-product-grid",
      function (e) {
        var items = document.querySelectorAll(
          ".product-card-item.product-item-loaded"
        );
        if (items.length > 0) {
          var classAll = items[0].className;
          classAll = classAll.replace("product-item-loaded", "");
          gsap.set(".product-card-item.product-item-loaded", {
            opacity: 0,
          });
          gsap.set(".product-card-item.product-item-loaded", {
            willChange: "transform",
          });
          ScrollTrigger.batch(".product-card-item.product-item-loaded", {
            onEnter: (batch) =>
              gsap.to(batch, {
                autoAlpha: 1,
                stagger: 0.2,
                className: classAll,
                //className: "product-card-item mb-0",
              }),
            markers: false,
            start: "top 85%",
          });
        }
        globalAnimation.animationEffects(e);
      }
    );

    document.addEventListener("DOMContentLoaded", function (e) {
      sectionAnimation.cardsAnimation(e);
    });
    document.addEventListener("shopify:section:load", function (e) {
      sectionAnimation.cardsAnimation(e);
    });
    document.addEventListener("shopify:section:unload", function (e) {
      sectionAnimation.cardsAnimation(e);
    });
    document.addEventListener("shopify:section:reorder", function (e) {
      sectionAnimation.cardsAnimation(e);
    });
    var resizeTimer = null;
    window.addEventListener("resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        ScrollTrigger.refresh();
      }, 250);
    });
  }
}
//Theme editor JS
if (Shopify.designMode == true) {
  var infoWrapWidth = 0;
  function updateInfoWrapWidth() {
    var el = document.querySelector("#product-info");
    if (el != null) {
      infoWrapWidth = el.offsetWidth;
    }
  }
  updateInfoWrapWidth();
  window.addEventListener("resize", updateInfoWrapWidth);
  document.onscroll = function () {
    stickyProductThumbSection();
    stickyProductMediaSection();
  };
  document.addEventListener("shopify:section:load", function (e) {
    setTimeout(function(){
      var infoWrap = document.querySelector("#product-info");
      if(infoWrap != null){
        infoWrap.style.position = "relative";
        infoWrap.style.removeProperty("top");
        infoWrap.style.removeProperty("width");
      }
    }, 600);
  });
  function stickyProductMediaSection() {
    var mediaWrap = document.querySelector("#product-media");
    var infoWrap = document.querySelector("#product-info");
    if (mediaWrap != null && infoWrap != null) {
      var row = infoWrap.closest(".grid");
      if (window.innerWidth > 767) {
        var hm = mediaWrap.offsetHeight;
        var hi = infoWrap.offsetHeight;
        var diffmi = hm - hi;
        if (hm > hi) {
          infoWrap.style.position = "fixed";
          infoWrap.style.setProperty("width", infoWrapWidth + "px", "");
          var rect = mediaWrap.getBoundingClientRect();
          var scrolledMedia = -rect.top;
          if (scrolledMedia >= diffmi) {
            infoWrap.style.position = "relative";
            row.style.setProperty("align-items", "end", "");
            infoWrap.style.removeProperty("top");
          } else if (scrolledMedia < diffmi) {
            infoWrap.style.position = "fixed";
            row.style.removeProperty("align-items");
            infoWrap.style.setProperty("top", "0", "");
          }
          if (Math.sign(scrolledMedia) == -1) {
            infoWrap.style.position = "relative";
            row.style.removeProperty("align-items");
            infoWrap.style.removeProperty("top");
            infoWrap.style.removeProperty("width");
          }
        }
      } else {
        infoWrap.style.position = "relative";
        row.style.removeProperty("align-items");
        infoWrap.style.removeProperty("top");
        infoWrap.style.removeProperty("width");
      }
    }
  }
  function stickyProductThumbSection() {
    var mediaWrap = document.querySelector("#product-media");
    var infoWrap = document.querySelector("#product-media-thumbnail");
    if (mediaWrap != null && infoWrap != null) {
      var row = infoWrap.closest(".grid");
      if (window.innerWidth > 767) {
        var hm = mediaWrap.offsetHeight;
        var hi = infoWrap.offsetHeight;
        var diffmi = hm - hi;
        if (hm > hi) {
          infoWrap.style.position = "fixed";
          infoWrap.style.setProperty("width", infoWrapWidth + "px", "");
          var rect = mediaWrap.getBoundingClientRect();
          var scrolledMedia = -rect.top;
          if (scrolledMedia >= diffmi) {
            infoWrap.style.position = "relative";
            row.style.setProperty("align-items", "end", "");
            infoWrap.style.removeProperty("top");
          } else if (scrolledMedia < diffmi) {
            infoWrap.style.position = "fixed";
            row.style.removeProperty("align-items");
            infoWrap.style.setProperty("top", "0", "");
          }
          if (Math.sign(scrolledMedia) == -1) {
            infoWrap.style.position = "relative";
            row.style.removeProperty("align-items");
            infoWrap.style.removeProperty("top");
            infoWrap.style.removeProperty("width");
          }
        }
      } else {
        infoWrap.style.position = "relative";
        row.style.removeProperty("align-items");
        infoWrap.style.removeProperty("top");
        infoWrap.style.removeProperty("width");
      }
    }
  }
}
//Sticky header
document.addEventListener("DOMContentLoaded", function (e) {
  const navbar = document.querySelector(".header-infinite");
  if (navbar == null) return;

  // Create a sentinel element above the header to observe
  // This avoids observing the navbar itself which causes layout shift
  // when it toggles between static and fixed positioning
  var sentinel = document.createElement("div");
  sentinel.style.height = "0";
  sentinel.style.width = "0";
  sentinel.style.position = "relative";
  sentinel.setAttribute("aria-hidden", "true");
  navbar.parentNode.insertBefore(sentinel, navbar);

  var stickyNav = function (entries) {
    var entry = entries[0];
    if (!entry.isIntersecting) {
      navbar.classList.add("sticky");
    } else {
      navbar.classList.remove("sticky");
    }
  };

  var headerObserver = new IntersectionObserver(stickyNav, {
    root: null,
    threshold: 0,
    rootMargin: "0px",
  });

  if (window.innerWidth > 767) {
    headerObserver.observe(sentinel);
  }
});
